export const productTypeOptions = [
  { value: 'Flower', label: 'Flower' },
  { value: 'Vapes', label: 'Vapes' }
];

export default {
  productTypeOptions
};
